import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import PropTypes from 'prop-types';
//import SearchInput from '../common/generic/SearchInput';
import AddUserComp from './AddUserComp';
import { TitleBar, ClassIconSelected, evenRowColor } from '../common/theme';
import { sort, isObjectEmpty, toArray, convertDictionaryKeys } from '../../Utils';
import { debounce } from 'lodash';
import { getCreateUserStatus, properName } from '../../ApiHelper';
import Spinner from '../common/generic/Spinner';
import ErrorDialog from '../common/ErrorDialog';

const ContainerComp = ({pageState}) =>{ 
    return <>{pageState.classesData && <div><ClassTableComp pageState={pageState}/></div>}</>;
};

ContainerComp.propTypes = {
    pageState: PropTypes.object
};

const ClassTableComp = ({pageState}) => {

    const [classData, setClassData] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [canSave, setCanSave] = useState(false);
    const [disableButtons, setDisableButtons] = useState(true);
    const [isSavingChanges, setIsSavingChanges] = useState(false);
    const [dialogError, setDialogError] = useState({show:false});

    const componentState ={
        classData, setClassData,
        editMode, setEditMode,
        canSave, setCanSave
    };
    
    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col style={{textAlign: 'left'}} xs='6'>Class Name</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Username (case sensitive)</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Password</Col>
    </Row>;
     const titleRowLTI = <Row style={{fontWeight:'bold'}}>
        <Col style={{textAlign: 'left'}} xs='12'>Class Name</Col>
    </Row>;
    
    useEffect(()=>{
        setDisableButtons(classData.reduce((acc,e)=>{if(e.isSelected) acc=false; return acc;},true));
    },[classData]);

    useEffect(() => {        
        if(!pageState.database['getCustomer']) return;
        const isLTIMode=()=>(sessionStorage.getItem('LTIMode') !== null);
        // show add class screen if there are no classes
        if(toArray(pageState.database['getAllClasses'].data).length===0 && !pageState.showImportUsersComp){
            if(!isLTIMode() && !pageState.showAddUserComp)
            pageState.showAddUserScreen('Class');
            return;
        }

        let customer = pageState.database['getCustomer'].data;

        if(pageState.database['saveClassCredentials'] && pageState.database['saveClassCredentials'].isLoaded){
            pageState.deleteThis('saveClassCredentials');
            pageState.deleteThis('getAllClasses');

            let getAllClassesQuery = {
                params:customer.ID,
                func:'getAllClasses',
              };
              pageState.request(getAllClassesQuery);
        }
    });

    useEffect(()=>{
        let nextState = [...componentState.classData];
        nextState = nextState.map(el=>{return{...el, isSelected:false};});
        componentState.setClassData(nextState);  
    },[pageState.showClassTableComp]);

    // reload and sort classes
    useEffect(()=>{
        if(pageState.database['getAllClasses'] && pageState.database['getAllClasses'].isLoaded){

            Object.keys(pageState.database['getAllClasses'].data).map((classKey) => {
                let classRec = pageState.database['getAllClasses'].data[classKey];
                let allStudentsArray = toArray(pageState.database['getAllStudentsForSchool'].data); 
                let studentRecs = allStudentsArray.filter(studentRec => studentRec.ClassID === classRec.ClassID);           
                pageState.database['getAllClasses'].data[classKey].students = studentRecs;
            });            

            pageState.database['getAllClasses'].data = convertDictionaryKeys(pageState.database['getAllClasses'].data, 'ClassID');
            let arrayData = Object.keys(pageState.classesData).map((key) => pageState.classesData[key])
                .sort((a,b) => (a.Classname.toUpperCase() > b.Classname.toUpperCase()) ? 1 : (a.Classname.toUpperCase() < b.Classname.toUpperCase() ? -1 : 0))
                .map(e=>{return {...e, isSelected:false};});
            setClassData(arrayData);
        }
    },[pageState.database['getAllClasses']]);

    const saveClicked = () =>{
        if(isObjectEmpty(pageState.classEditsForSave)) return;

        let saveQuery = [];

        Object.keys(pageState.classEditsForSave).map((key, i) => {
            let {id, classL, classP, classN} = pageState.classEditsForSave[key].original;
            if(pageState.classEditsForSave[key].changed){
                classL= (pageState.classEditsForSave[key].changed.classL)?pageState.classEditsForSave[key].changed.classL:classL;
                classP= (pageState.classEditsForSave[key].changed.classP)?pageState.classEditsForSave[key].changed.classP:classP;
                classN= (pageState.classEditsForSave[key].changed.classN)?pageState.classEditsForSave[key].changed.classN:classN;
            }
            let prevQuery = (i!=0) ? saveQuery[i-1] : 'undefinded';
            let query = {
                params:`${id}~${classN.trim()}~${classL.trim()}~${classP.trim()}`,
                func:'saveClassCredentials'   
            };
            if(prevQuery !== 'undefinded')
                query.nextRequest = prevQuery;
            saveQuery.push(query);
        });
        pageState.setClassEditsForSave({});
        pageState.request(saveQuery[saveQuery.length-1]); 
    };
    const isSaving = () => (pageState.database['saveClassCredentials'] && !pageState.database['saveClassCredentials'].isLoaded);
    const isLoading = () => (pageState.database['getAllClasses'] && !pageState.database['getAllClasses'].isLoaded);

    const printPasswords=()=>{
        var w = window.open();

        if(!w || !w.document.write || w.closed || typeof w.closed=='undefined') 
        { 
            setDialogError({title:'Problem showing reports', text:'Please turn off your pop-up blocker to see the class password list', show:true});
            return;
        }

        var schoolName = pageState.database['getCustomer'].data['NAME'];
        var schoolURLNum = pageState.database['getCustomer'].data['URL_NUM'];
        var header = `<html><head><title>Use Browser to Print</title><style>body {font-family: Arial, Helvetica, sans-serif;}</style></head><body><center><H3>Class passwords for ${schoolName}</H3><H4>SchoolID: ${schoolURLNum}</H4><H4>online.essentialskills.com</H4></center>`;
        var html = '<table style="margin: 0px auto;" width="600px"><tr><th align="left">Name</th><th align="left">Username (case sensitive)</th><th align="left">Password</th></tr>';

        classData.forEach(classRec => {
            let pass=(classRec.Password)?classRec.Password:''; 
            html += `<tr><td>${classRec.Classname}</td><td>${classRec.Username}</td><td>${pass}</td></tr>`;
        });
        var footer = '</body></html>';
        w.document.write(header+html+footer);
        w.document.close();
    };

    const deleteClasses=()=>{
        if(!window.confirm('Are you sure you want to delete the selected class(es)?'))
            return;

        let schoolID = pageState.database['getCustomer'].data['ID'];
        let saveChanges = [];

        classData.forEach(classRec=>{
            if(classRec.isSelected){
                let classID = classRec.ClassID;
                saveChanges.push({debug:'Delete Class', func:'deleteTeacher', params: `${classID}~${schoolID}~0`});
                saveChanges.push({debug:'Backup Class', func:'backupTeacher', params: `${classID}`});
            }
        });

        // create a link list of save changes querys for saving to the database
        if(saveChanges.length > 0){
            setIsSavingChanges(true);
            let counter = 1;
            saveChanges = saveChanges.map((query,i)=>{
                let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
                if(prevQuery !== 'undefinded'){
                    counter++;
                    query.nextRequest = prevQuery;
                }
                return query;
            });
            let saveChainedChanges = saveChanges[saveChanges.length-1];
            saveChainedChanges.numQueries = counter;
 
            // tell the customer record that some classes were deleted
            counter = counter/2;
            let currentNumClasses = parseInt(pageState.database['getCustomer'].data['NumClasses']);
            currentNumClasses = (currentNumClasses - counter < 0)?0:(currentNumClasses - counter);            
            pageState.database['getCustomer'].data['NumClasses'] = currentNumClasses+''; 

            // pass the link list of saved changes into the database
            pageState.request(saveChainedChanges); 
        }
    };

    // check if done saving
    useEffect(()=>{
        if(isSavingChanges){
            if(pageState.database['deleteTeacher'] && pageState.database['deleteTeacher'].isLoaded){
                pageState.database['deleteTeacher'].isLoaded = false; // don't double use
                let counter = parseInt(pageState.database['deleteTeacher'].data['StudentCount']);
                let currentNumStudents = parseInt(pageState.database['getCustomer'].data['NumStudents']);
                currentNumStudents = (currentNumStudents - counter < 0)?0:(currentNumStudents - counter);
                pageState.database['getCustomer'].data['NumStudents'] = currentNumStudents+''; 
            }
            if(pageState.database.queryCount == 0){
                let customer = pageState.database['getCustomer'].data;
                setIsSavingChanges(false);
                pageState.deleteThis('getAllClasses');

                let getAllClassesQuery = {
                    params: customer.ID,
                    func:'getAllClasses',
                  };
                  pageState.request(getAllClassesQuery);            
            }
        }
    },[pageState.database.queryCount]);

    const selectAll = () => {
        let nextState = [...componentState.classData];
        nextState = nextState.map(el=>{return{...el, isSelected:true};});
        componentState.setClassData(nextState);      
    };

    const unselectAll = () => {
        let nextState = [...componentState.classData];
        nextState = nextState.map(el=>{return{...el, isSelected:false};});
        componentState.setClassData(nextState);      
    };

    const cancelEdit=()=>{
        setEditMode(false); 
        setCanSave(false); 
        pageState.setClassEditsForSave({});
    };

    const isLTIMode=()=>(sessionStorage.getItem('LTIMode') !== null);
    // if(!pageState.showClassTableComp && editMode)
    //     cancelEdit();
        
    return ((!pageState.showClassTableComp)?<></>:<>
        {(isSavingChanges || isSaving() || isLoading())?
        <> <Spinner/> <center><h1>Processing... ({pageState.database['queryCount']})</h1></center></>:<>
        <Container>
            {!isLTIMode() && <><Col xs='12'><Button variant="success" onClick={()=>pageState.showAddUserScreen('Class')} >New Class</Button><br/>&nbsp;</Col></>}

            <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='2'><h3>Classes</h3></Col>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='10'>
                {!isLTIMode() &&
                    <span className={'pull-right'}>
                        {!(editMode) && <> <Button  onClick={printPasswords} variant="warning">Password List</Button> &nbsp; </>}
                        {(!(editMode)) && <><Button variant="danger" onClick={deleteClasses} disabled={disableButtons}>Delete</Button> &nbsp;</>}
                        {!(editMode) && <> <Button onClick={()=>setEditMode(true)} variant="success">Edit</Button> &nbsp;</>}
                        {(editMode) && <> <Button onClick={saveClicked} variant="success" disabled={!canSave} >Save</Button> &nbsp; </>}
                        {(editMode) && <> <Button onClick={()=>cancelEdit()} variant="danger" >Cancel</Button> &nbsp; </>}
                    </span>    
                }
                </Col>
            </TitleBar>
        </Container>            
        <div style={{overflowY:'scroll', overflowX : 'hidden',height:'300px', padding:'10px', borderBottom: '1px solid #cfcfcf', borderLeft: '1px solid #cfcfcf', borderRight: '1px solid #cfcfcf'}}>
            {!isLTIMode() && titleRow}
            {isLTIMode() && titleRowLTI}
            {classData.map((classRec, i) => 
                <ClassRow style={{cursor:'pointer'}} key={i} index={i} classState={classRec} componentState={componentState} pageState={pageState} />
            )}
        </div>
        {(!isLTIMode() && !(editMode)) && <Col xs={12}><Button onClick={selectAll}>Select All</Button>&nbsp;<Button onClick={unselectAll}>Unselect All</Button></Col>} 
        <br/>
        <CheckIfCanSave componentState={componentState} pageState={pageState}/>
    </>}<ErrorDialog dialogState={{dialogError, setDialogError}} /></>
    );
};

const CheckIfCanSave = ({pageState, componentState}) =>{
    const hasCellError=(colName, newState)=>{
        if (typeof newState.changed[colName] === 'undefined') { return false;} 
        if((newState.changed[colName])==='') return true; // check is the column is empty ''
        if(!(newState.changed[colName])) return false; // check if the column has any change data

        let userItem = newState.changed[colName];
        let takenList = [];      
        
        takenList = (colName === 'classN') ? componentState.classData.filter(e=>e.ClassID!==newState.id).map(e=>e.Classname) : takenList;
        takenList = (colName === 'classL') ? componentState.classData.map(e=>e.Username) : takenList;
        
        let status = getCreateUserStatus(colName, userItem, true, takenList,(colName === 'classL'));
        if(status.error) return true;

        // dont let teachers save changes with 2 of the same names
        let foundError = false;
        if(colName !=='classP'){
            Object.keys(pageState.classEditsForSave).forEach((key) => {
                if(pageState.classEditsForSave[key].id !== newState.id && pageState.classEditsForSave[key].changed){
                    if(pageState.classEditsForSave[key].changed[colName] && pageState.classEditsForSave[key].changed[colName] === newState.changed[colName]){
                        foundError = true;
                    }
                }
            });
        }
        if(foundError) return true;

        return false; 
    };  

    // check if you can save        
    const hasError = Object.keys(pageState.classEditsForSave).reduce((acc, key) => {
        let cell = pageState.classEditsForSave[key];
        if(cell.changed){
            if(hasCellError('classN',cell)) {acc=true;};
            if(hasCellError('classL',cell)) {acc=true;};
            if(hasCellError('classP',cell)) {acc=true;};
        }
        return acc;
    },false);
    if(componentState.canSave !== !hasError)
        componentState.setCanSave(!hasError);

    return <></>;
};

const ClassRow = ({classState, pageState, componentState, index}) => {
    const isLTIMode=()=>(sessionStorage.getItem('LTIMode') !== null);
    
    const {ClassID, Username, Classname, Password, isSelected} = classState;
    const selectedStyle = (isSelected) ? {backgroundColor:'lightblue'} : (index%2==0)?{background:evenRowColor}:{};

    const displayStudents = () => {
        let classInfo = {ClassID, Classname};
        pageState.setPageType('Student');
        pageState.showStudentScreen({display:true, classInfo});
    };

    const rowStyle = {
        margin: '2px', 
        borderBottom: '1px solid #cfcfcf',
        cursor: 'pointer'
    };
    
    const editRowStyle = {
        margin: '2px', 
        borderBottom: '1px solid #cfcfcf',
    };
    
    const green = '#AFFFAF', red = '#FFAFAF', blue='#AFAFFF', white='#FFFFFF';
    const showError=(colName)=>{
        if(!(ClassID in pageState.classEditsForSave)) return {backgroundColor: white}; // check if the class is in the change list
        if((pageState.classEditsForSave[ClassID].changed[colName])==='') return {backgroundColor:red}; // check is the column is empty ''
        if(!(pageState.classEditsForSave[ClassID].changed[colName])) return {backgroundColor: white}; // check if the column has any change data

        let userItem = pageState.classEditsForSave[ClassID].changed[colName];
        let newState_id = pageState.classEditsForSave[ClassID].id;
        let takenList = [];        
        
        takenList = (colName === 'classN') ? componentState.classData.filter(e=>e.ClassID!==newState_id).map(e=>e.Classname) : takenList;
        takenList = (colName === 'classL') ? componentState.classData.map(e=>e.Username) : takenList;
        
        let status = getCreateUserStatus(colName, userItem, true, takenList, (colName === 'classL'));
        if(status.error) return  {backgroundColor: red};
        
        // dont let teachers save changes with 2 of the same names
        let foundError = false;
        if(colName !=='classP'){
            Object.keys(pageState.classEditsForSave).forEach((key) => {
                if(pageState.classEditsForSave[key].id !== ClassID && pageState.classEditsForSave[key].changed && pageState.classEditsForSave[key].changed[colName]){
                    if( pageState.classEditsForSave[key].changed[colName] === pageState.classEditsForSave[ClassID].changed[colName]){
                        foundError = true;
                    }
                }
            });
        }
        if(foundError) return {backgroundColor: red};

        return {backgroundColor: green}; 
    };

    const handleChange = debounce((text, name) =>{
        let nextState = {...pageState.classEditsForSave};

        nextState[classState.ClassID] = {
            original:{
                id:ClassID, classN: Classname, classL: Username, classP: Password
            },
            id:ClassID, classN: Classname, classL: Username, classP: Password
        };

        if(pageState.classEditsForSave[classState.ClassID] && pageState.classEditsForSave[classState.ClassID].changed )
        nextState[classState.ClassID].changed = {...pageState.classEditsForSave[classState.ClassID].changed};

        nextState[classState.ClassID][name] = text;

        let changed = {}; // combined all changes per row
        if(nextState[classState.ClassID].changed)
            changed = {...nextState[classState.ClassID].changed};
        
        changed[name] = text;
        nextState[classState.ClassID].changed=changed;

        // check to see if they reverted their changes
        if(changed[name] === nextState[classState.ClassID].original[name])
            delete changed[name];

        if(isObjectEmpty(changed)) // remove row edit if everything is back to the way it was
            delete nextState[classState.ClassID];      

        pageState.setClassEditsForSave(nextState);
    },250);

    const toggleSelect = (classID) => {
        let nextState = [...componentState.classData];
        let classIdx = nextState.findIndex(el => el.ClassID === classID);
        nextState[classIdx].isSelected = !nextState[classIdx].isSelected;
        componentState.setClassData(nextState);      
    };

    return (
        <>
        {!isLTIMode()&&<>
            {(componentState.editMode) && <>
                <Row className={'form-group'} style={editRowStyle}>
                    <Col style={{textAlign: 'left'}} xs='6'> <input style={showError('classN')} type="text" className={'form-control'} name={'classN'} onChange={e => handleChange(e.target.value, e.target.name)} defaultValue={Classname}/> </Col>
                    <Col style={{textAlign: 'left'}} xs='3'> <input style={showError('classL')} type="text" className={'form-control'} name={'classL'} onChange={e => handleChange(e.target.value, e.target.name)} defaultValue={Username}/> </Col>
                    <Col style={{textAlign: 'left'}} xs='3'> <input style={showError('classP')} type="text" className={'form-control'} name={'classP'} onChange={e => handleChange(e.target.value, e.target.name)} defaultValue={Password}/> </Col>
                </Row>
            </>}

            {!(componentState.editMode) && <>
                <Row style={selectedStyle}>
                    <Col style={{textAlign: 'left'}} xs='6'> 
                        <ClassIconSelected onClick={() => toggleSelect(ClassID)} isSelected={isSelected}/> &nbsp;
                        <span style={{color:'blue',textDecoration:'underline',cursor: 'pointer'}} onClick={()=>displayStudents()}>{Classname}</span> 
                    </Col>
                    {/* <Col style={{color:'blue',textDecoration:'underline',textAlign: 'left'}} xs='6'> {Classname} </Col> */}
                    <Col style={{textAlign: 'left'}} xs='3'> {Username} </Col>
                    <Col style={{textAlign: 'left'}} xs='3'> {'*****'} </Col>
                </Row>
            </>}
            </>}

            {isLTIMode()&&
                <Row style={selectedStyle}>
                    <Col style={{textAlign: 'left'}} xs='12'>                         
                        <span style={{color:'blue',textDecoration:'underline',cursor: 'pointer'}} onClick={()=>displayStudents()}>{Classname}</span> 
                    </Col>
                </Row>
            }
        </>
    );
};

export default ContainerComp;